import React from 'react';
import PropTypes from 'prop-types';
import './Messages.scss';

const getMessageLink = (messageLinkData) => {
  if (messageLinkData) {
    return (
      <a
        className="address-search-message"
        href={messageLinkData.href}
        target="_blank"
        rel="noopener noreferrer"
      >
        {messageLinkData.text}
      </a>
    );
  }
  return null;
};

const Message = (props) => {
  const { message, messageLinkData, messageAfterLink, address, onLinkClick, actionText, iconClassName } = props;
  return (
    <div className="address-search-messages">
      {address &&
      <p className="address-search-messages-show-address autotest-address-search-result-address">
        {address}
      </p>
      }
      {onLinkClick &&
      <p className="address-search-clear">
        <a className="autotest-clear-address" href="/" onClick={onLinkClick}>
          {actionText}
        </a>
      </p>
      }
      {iconClassName &&
      <div>
        <div className={iconClassName} />
        <div className="address-search-messages-text autotest-address-search-problem-message">
          {message}
          {getMessageLink(messageLinkData)}
          {messageAfterLink}
        </div>
      </div>
      }
      {!iconClassName &&
      <div className="messages-text-no-icon autotest-address-search-problem-message">
        {message}
        {getMessageLink(messageLinkData)}
        {messageAfterLink}
      </div>
      }
    </div>
  );
};

Message.propTypes = {
  message: PropTypes.string.isRequired,
  messageLinkData: PropTypes.object,
  messageAfterLink: PropTypes.string,
  address: PropTypes.string,
  onLinkClick: PropTypes.func,
  actionText: PropTypes.string,
  iconClassName: PropTypes.string
};

export default Message;



/** WEBPACK FOOTER **
 ** ./src/components/message/Message.js
 **/